import { z } from 'zod';
export const EmailSafeImageExtensionSchema = z.enum(['png', 'jpg', 'jpeg']);
export const EmailSafeImageExtensionEnum = EmailSafeImageExtensionSchema.enum;
export const EmailSafeImageExtensions = EmailSafeImageExtensionSchema.options;
export const EMAIL_SAFE_IMAGE_EXTENSIONS = new Set(EmailSafeImageExtensions);
export const isEmailSafeImageExtension = (extension) => {
    return !!extension && EMAIL_SAFE_IMAGE_EXTENSIONS.has(extension);
};
